<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item, index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control == "Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control == "Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control == "Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control == "Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control == "Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control == "Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control == "File"' :data-val="item"></File>
			<Table v-if='item.Property.Control == "Table"' @child-event='tableOperation' :data-val='item'
				:template-data='templateData'></Table>
			<Selector v-if='item.Property.Control == "Selector"' @child-event='getSelectorVal' :data-val='item'>
			</Selector>
			<Textarea v-if='item.Property.Control == "Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control == "Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<!-- <List :data-val="valData" @child-event='getListVal'></List>
		<a href="/static/export.xlsx" download="export" style="color: #FF0000; text-decoration: underline">下载导入模板</a> -->
		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from '../components/Number.vue'
import Contact from '../components/Contact.vue';
import Dates from '../components/Date.vue';
import Version from '../components/Text.vue';
import Money from '../components/Money.vue';
import Tips from '../components/Tips.vue';
import File from '../components/File.vue';
import Table from '../components/Table.vue';
import Selector from '../components/Selector.vue';
import Textarea from '../components/Textarea.vue';
import Choose from '../components/Choose.vue';
import wx from 'weixin-js-sdk'
import stringUtils from "../assets/js/stringUtil.js";
// import List from '../components/List.vue';
import {
	initWxConfig
} from '../api/jssdk.js';
import {
	getTemplateInfo,
	submitProcess,
	sendMessage
} from '@/api/approval'
import {
	getDepartmentRelationByName,
	getDepartmentRelationById,
	getDepartmentInfo
} from '@/api/department'
import {
	getRelation
} from '@/api/employee'

var isSubmit = false;

var template = {
	TemplateContent: {
		Controls: []
	}
};
const sendMessagetTemplate = {
	title: null,
	url: null,
	toUser: [],
	desc: null,
	template: null,
};
export default {
	components: {
		Contact,
		Dates,
		Version,
		Money,
		Tips,
		File,
		Table,
		Digit,
		Selector,
		Textarea,
		Choose
		// ,List
	},
	data() {
		return {
			templateData: template,
			relationList: null,
			logInfo: null,
			templateId: "",
			spNo: null,
			sendMessageData: Object.assign({}, sendMessagetTemplate),
			formLoading: false,
			listLoading: false,
			flowId: null,
			valData: {
				TotalCount: 0,
				listTitle: [{
					type: 'selection',
					width: 45,
					align: 'center',
					fixed: 'left'
				},
				{
					title: '资产编号',
					key: 'AssetsCode',
					width: 120,
					disabled: true
				}],
				listData: [],
				isDisabled: false
			}
		}
	},
	created() {
		initWxConfig(this);
		this.logInfo = this.getLoginUserInfo();
		this.templateId = this.$route.query.templateId;
		this.flowId = this.$route.query.flowId;
		this.getTemplate();
	},
	methods: { //方法

		clickChoose: async function (dataVal, name) {
			var that = this;
			window.wx.invoke("selectEnterpriseContact", {
				"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
				"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
				"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
				"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
			}, async function (res) {
				if (res.err_msg == "selectEnterpriseContact:ok") {
					if (typeof res.result == 'string') {
						res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
					}
					var depart = res.result.departmentList[0]; // 已选的部门列表
					dataVal.Values = [];
					dataVal.Value = depart.name;
					dataVal.Values.push([depart.id, depart.name]);
					getDepartmentInfo(depart.id).then(async res => {
						var departFullName = res.Body.FullName;
						var ApiDep = departFullName;
						var departName = departFullName.split("/");
						that.templateData.TemplateContent.Controls.forEach(async (item, index) => {
							if ((departName.indexOf("住宅部") > -1 && departName.indexOf("按揭金融服务中心") === -1) || departName.indexOf("住宅行政支持组") > -1 || departName.indexOf("住宅部支援中心") > -1) {
								if (item.Property.Title[0].Text == "行政主任") {
									item.Values = [];
									item.Values = await that.getDepartmentRelation(depart.id, "行政主任");
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(["SC24000029", "钟志斌"]);
									}
								}
								if (item.Property.Title[0].Text == "行政经理") {
									item.Values = [];
									item.Values = await that.getDepartmentRelation(depart.id, "行政经理");
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(["SC24000029", "钟志斌"]);
									}
								}
								if (item.Property.Title[0].Text == "小战区区董") {
									item.Values = [];
									item.Values = await that.getDepartmentRelation(depart.id, "战区董事", true);
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(["SC24000029", "钟志斌"]);
									}
								}
								if (item.Property.Title[0].Text == "大战区区董") {
									item.Values = [];
									item.Values = await that.getDepartmentRelation(depart.id, "董事总经理", true);

									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(["SC24000029", "钟志斌"]);
									}
								}
							} else {
								if (item.Property.Title[0].Text == "经理/总监") {
									item.Values = [];
									item.Values = await that.getDepartmentRelationList(depart.id, 5, "经理", false);
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										//小部门的总经理
										item.Values = await that.getDepartmentRelationList(depart.id, 7, "总监", false);
									}
									if (departFullName.indexOf("华西区/房友圈/联动拓展部") > -1) {
										item.Values = await that.getDepartmentRelationList(depart.id, 7, "联动拓展总经理");
									}

									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(["SC24000029", "钟志斌"]);
									}


									item.IsShow = false;
								}
								if (item.Property.Title[0].Text == "总经理") {
									item.Values = [];
									await getDepartmentRelationByName(departFullName, false).then(res => {
										if (res.Body != null) {
											for (var i = 0; i < res.Body.length; i++) {
												for (const depData of res.Body[i].Nodes) {
													if (depData.Items != null) {
														depData.Items.forEach((userData) => {
															if (userData.PositionName.indexOf("总经理") > -1 && userData.JobLevel > 5) {
																if (item.Values == null || item.Values.length == 0) {
																	var insertDat = [userData.EmpNo, userData.EmpName]
																	item.Values.push(insertDat);
																	return;
																}
															}
														})
													}
												}
											}
										} else {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
										if (item.Values == null || item.Values.length == 0) {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}


									});
								}
							}
							if (item.Property.Title[0].Text == "逐级审批") {
								item.Values = [];
								item.IsShow = false;
								if (departFullName.indexOf("综合事务部") > -1) {
									await getRelation(that.logInfo.EmpNo).then(response => {
										response.Body[0].Nodes.forEach(findItems => {
											if (findItems.Items != null) {
												for (let i = 0; i < findItems.Items.length; i++) {
													if (findItems.Items[i].JobLevel >= 10) {
														continue;
													}
													item.Values.push([findItems.Items[i].EmpNo, findItems.Items[i].EmpName])
												}
											}
										})
									})
								} else {
									await getDepartmentRelationById(res.Body.DeptId).then(data => {
										if (data.Body != null && data.Body.length > 0) {
											for (var i = 0; i < data.Body[0].Nodes.length; i++) {
												var depData = data.Body[0].Nodes[i];
												if (depData.DeptName == "非营业部") {
													break;
												}
												if (depData.Items != null) {
													depData.Items.sort(function (a, b) {
														return a.JobLevel - b.JobLevel
													})
													depData.Items.forEach((userData) => {
														if (that.logInfo.EmpNo != userData.EmpNo) {
															var insertDat = [userData.EmpNo, userData.EmpName]
															item.Values.push(insertDat)
														}
													})
												}
											}

										} else {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
									});
								}

								if (departFullName === "华西区/四川中原物业顾问有限公司/非营业部/职能中心/人才发展部/培训部" || departFullName === "华西区/四川中原物业顾问有限公司/非营业部/职能中心/人才发展部/招聘部") {
									item.Values = []
									item.Values.push(["SC17001303", "陈醴"])
									item.Values.push(["SC02120002", "卢华"])
								}
								item.Values = that.applyZhujishenpiValues(item.Values, "AdministrativeProcurementApplication", { fullName: departFullName });
								if (item.Values == null || item.Values.length == 0) {
									item.Values = [
										["SC24000029", "钟志斌"]
									]
								}



								console.log('逐级审批人', item.Values);
							}

							if (item.Property.Title[0].Text == "请选择审批流程") {
								var departs = that.logInfo.fullName;
								var ApiDep = departFullName;
								if (ApiDep.indexOf("华西区") > -1) {
									if (departs.indexOf("华西区信息中心") > -1) {
										item.Value = "option-1600689940132"
										item.IsShow = false;
									} else if (departs.indexOf("中国大陆华西区总裁办") > -1) {
										item.Value = "option-1600689940131"
										item.IsShow = false;
									} else {
										item.IsShow = true;
										item.Config.Selector.Options[0].Value[0].Text = "区域总裁助理聂丽娟审批";
										item.Config.Selector.Options[1].Value[0].Text = "华西区信息中心经理";
									}
								}
								if (ApiDep.indexOf("按揭金融服务中心") > -1) {
									item.Value = "option-1600689940132"
									item.IsShow = false;
								}
								if (ApiDep.indexOf("华西区/原友信") > -1) {
									item.Value = "option-1600689940132"
									item.IsShow = false;
								}
								if (ApiDep.indexOf("华西区/四川中原物业顾问有限公司/非营业部") > -1) {
									item.Value = "option-1600689940132"
									item.IsShow = false;
								}
								if ((ApiDep.indexOf("住宅部") > -1 && ApiDep.indexOf("按揭金融服务中心") === -1) || ApiDep.indexOf("住宅行政支持组") > -1 || ApiDep.indexOf("住宅部支援中心") > -1) {
									if (that.logInfo.EmpNo == "SC15004802") {
										item.Value = "option-1600689940131"
										item.IsShow = false;
									} else if (departs.indexOf("住宅行政支持组") > -1) {
										item.Value = "option-1600689940132"
										item.IsShow = false;
									} else {
										item.IsShow = true;
										item.Config.Selector.Options[0].Value[0].Text = "住宅部支援中心经理审批";
										item.Config.Selector.Options[1].Value[0].Text = "行政主任审批";
									}
								}
								if (ApiDep.indexOf("工商铺商业运营中心") > -1 || ApiDep.indexOf("商业地产部") > -1) {
									item.Value = "option-1600689940132"
									item.IsShow = false;
								}
								if (ApiDep.indexOf("华西区/房友圈") > -1 || ApiDep.indexOf("华西区/藤云") > -1) {
									if (departs.indexOf("华西区/房友圈") > -1 || departs.indexOf("华西区/藤云") > -1) {
										item.Value = "option-1600689940131"
										item.IsShow = false;
									}
									// else if (departs.indexOf("华西区/房友圈/非营业部/职能中心/后勤房友圈") > -1) {
									else if (departs.indexOf("华西区/藤云/非营业部/职能中心/后勤支持部/后勤藤云") > -1) {
										item.Value = "option-1600689940132"
										item.IsShow = false;
									} else {
										item.IsShow = true;
										item.Config.Selector.Options[0].Value[0].Text = "房友圈部门经理总监审批";
										item.Config.Selector.Options[1].Value[0].Text = "房友圈总经理助理刘晴审批";
									}
								}

								if (ApiDep.indexOf("二级市场营运中心") > -1 || ApiDep.indexOf("代理") > -1) {
									if (departs.indexOf("华西区/代理/非营业部/二级市场支援中心") > -1) {
										item.Value = "option-1600689940132"
										item.IsShow = false;
									} else if (departs.indexOf("二级市场") > -1) {
										item.Value = "option-1600689940131"
										item.IsShow = false;
									} else {
										item.IsShow = true;
										item.Config.Selector.Options[0].Value[0].Text = "运营部总经理/副总经理审批";
										item.Config.Selector.Options[1].Value[0].Text = "支援中心";
									}
								}
							}
							// if (item.Property.Title[0].Text == "申请人员部门") {
							// 	if ((departName.indexOf("住宅部") > -1 && departName.indexOf("按揭金融服务中心") === -1)||departName.indexOf("住宅行政支持组")>-1|| departName.indexOf("住宅部支援中心") > -1) {
							// 	  item.Value = item.Config.Selector.Options
							// 			.filter(item => {
							// 				return item.Value[0].Text == "住宅部";
							// 			})[0].Key;
							// 	} else if (departName.indexOf("工商铺商业运营中心") > -1 || departName.indexOf("商业地产部") > -1) {
							// 		item.Value = item.Config.Selector.Options
							// 			.filter(item => {
							// 				return item.Value[0].Text == "工商铺商业运营中心";
							// 			})[0].Key;
							// 	} else if ((departName.indexOf("房友圈") > -1 && departs.indexOf("职能中心") === -1)||departName.indexOf("藤云") > -1) {
							// 		item.Value = item.Config.Selector.Options
							// 			.filter(item => {
							// 				return item.Value[0].Text == "房友圈";
							// 			})[0].Key;
							// 	} else if (departName.indexOf("二级市场营运中心") > -1||departName.indexOf("代理") > -1) {
							// 		item.Value = item.Config.Selector.Options
							// 			.filter(item => {
							// 				return item.Value[0].Text == "二级市场营运中心/代理";
							// 			})[0].Key;
							// 	} else if (departName.indexOf("按揭金融服务中心") > -1) {
							// 		item.Value = item.Config.Selector.Options
							// 			.filter(item => {
							// 				return item.Value[0].Text == "汇瀚";
							// 			})[0].Key;
							// 	} else if (departName.indexOf("原友信") > -1) {
							// 		item.Value = item.Config.Selector.Options
							// 			.filter(item => {
							// 				return item.Value[0].Text == "原友信";
							// 			})[0].Key;
							// 	} else if (departName.indexOf("非营业部") > -1) {
							// 		item.Value = item.Config.Selector.Options
							// 			.filter(item => {
							// 				return item.Value[0].Text == "非营业部";
							// 			})[0].Key;
							// 	} else if (departName.indexOf("华西区") > -1) {
							// 		item.Value = item.Config.Selector.Options
							// 			.filter(item => {
							// 				return item.Value[0].Text == "华西区";
							// 			})[0].Key;
							// 	}
							// }

							//总体人员离职临时控制
							var replaceData = that.getZhujishenpiReplaceData("AdministrativeProcurementApplication");
							replaceData.forEach(ditem => {
								if (Array.isArray(item.Values)) {
									item.Values.forEach((subArr, i) => {
										if (Array.isArray(subArr) && subArr.includes(ditem.old)) {
											that.$set(item.Values, i, [ditem.new, ditem.name]);
										}
									});
								}
							});
							
						})
					});
				}
			})
		},
		getTemplate: async function () {
			this.listLoading = true;
			var title = this.logInfo.fullName;
			var jobLevel = this.logInfo.JobLevel;
			await getTemplateInfo(this.templateId).then(async response => {
				var controls = response.Body;
				await this.getEmployeeRelation();
				controls.TemplateContent.Controls.forEach(async (item, index) => {
					var departs = this.logInfo.fullName.split("/");
					if (item.Property.Control == "Table") {
						for (var i = 0; i < item.Config.Table.Children.length; i++) {
							var childItem = item.Config.Table.Children[i];
							if (childItem.Property.Title[0].Text == "预计金额") {
								childItem.Disable = true;
								break;
							}
						}
					}
					if (item.Property.Title[0].Text == "请选择审批流程") {
						item.IsShow = false;
						if (departs.indexOf("住宅部") > -1 && departs.indexOf("按揭金融服务中心")) {
							item.Value = item.Config.Selector.Options.filter(item => {
								return item.Value[0].Text == "1"
							})[0].Key;
						} else if (departs.indexOf("住宅行政支持组") > -1) {
							//分行行政
							item.Value = item.Config.Selector.Options.filter(item => {
								return item.Value[0].Text == "2"
							})[0].Key;
						} else if (departs.indexOf("房友圈") > -1) {
							if (departs.indexOf("后勤房友圈") > -1) {
								item.Value = item.Config.Selector.Options.filter(item => {
									return item.Value[0].Text == "2"
								})[0].Key;
							} else {
								item.Value = item.Config.Selector.Options.filter(item => {
									return item.Value[0].Text == "1"
								})[0].Key;
							}
						} else if (departs.indexOf("华西区") > -1) {
							if (departs.indexOf("华西区信息中心") > -1) {
								item.Value = item.Config.Selector.Options.filter(item => {
									return item.Value[0].Text == "2"
								})[0].Key;
							} else {
								item.Value = item.Config.Selector.Options.filter(item => {
									return item.Value[0].Text == "1"
								})[0].Key;
							}
						}
					}

					if (item.Property.Title[0].Text == "合计") {
						item.Disable = true;
					}
					if (item.Property.Title[0].Text == "小计") {
						item.Disable = true;
					}
					if (item.Property.Title[0].Text == "行政主任") {
						item.Values = []
						item.Values.push(this.$store.state.defaultMember);
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "行政经理") {
						item.Values = []
						item.Values.push(this.$store.state.defaultMember);
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "小战区区董") {
						item.Values = []
						item.Values.push(this.$store.state.defaultMember);
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "大战区区董") {
						item.Values = []
						item.Values.push(this.$store.state.defaultMember);
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "总经理") {
						item.Values = []
						item.Values.push(this.$store.state.defaultMember);
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "经理/总监") {
						item.Values = []
						item.Values.push(this.$store.state.defaultMember);
						item.IsShow = false;
					}

					if (item.Property.Title[0].Text == "维修") {
						item.IsShow = false;
					}
					if (item.Property.Title[0].Text == "逐级审批") {
						item.IsShow = false;
						item.Values = [
							["SC24000029", "钟志斌"]
						]
					}
					// if (item.Property.Title[0].Text == "申请人员部门") {
					// 	item.IsShow = false;
					// }
					if (item.Property.Title[0].Text == "姓名") {
						item.Disable = true;
					}
				});
				this.templateData = this.assignControl(controls, this.logInfo);
				this.templateData = await this.assignControlBySpNo(controls, null, this.flowId);
				this.listLoading = false;
				this.templateData.TemplateContent.Controls.forEach(control => {
					if (control.Property.Title[0].Text.indexOf("申请项目内容") > -1) {
						control.addIsShow = true;
					}
				})
			});

		},
		getEmployeeRelation: async function () {
			await getRelation(this.logInfo.EmpNo).then(response => {
				this.relationList = response.Body[0].Nodes;
			});
		},
		getTextVal() { },
		getSelectorVal(val, name) {
			if (name == "类别") {
				console.log("val")
				console.log(val)
				var controls = this.templateData.TemplateContent.Controls;
				var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
				var option = controlInfo.Config.Selector.Options
					.filter(item => {
						return item.Value[0].Text == "维修" && val.indexOf(item.Key) > -1;
					})[0];
				var control = controls.filter(item => item.Property.Title[0].Text == "维修")[0];
				if (option != null) {
					control.IsShow = true;
					control.Property.Require = 1;
				} else {
					control.IsShow = false;
					control.Property.Require = 0;
				}
			}
		},
		getListVal: async function (data, type) {
			var that = this;
			console.log(type)
			console.log(data)
		},
		tableOperation(val, type, datas) {
			if (type == 'compute') {
				return;
			}
			this.tableoperation(val, type, datas, this);
		},
		submit() {
			//数据校验
			if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
				return;
			}
			if (isSubmit) {
				this.Message({
					message: '已提交',
					type: 'warning',
					duration: 1000
				});
				return;
			}
			isSubmit = true;

			var controlInfoA = this.templateData.TemplateContent.Controls.filter(item => {
				return item.Property.Title[0].Text == "申请类别1"
			})[0];

			var controlInfoAText = controlInfoA.Config.Selector.Options.filter(t => {
				return t.Key == controlInfoA.Value
			})[0].Value[0].Text;

			this.templateData.TemplateContent.Controls.forEach(e => {
				if (e.Property.Require == 0 && (e.IsShow == null || !e.IsShow) && (e.Value == null || e.Value.length == 0) && e.Property.Title[0].Text == '备注') {
					e.Value = '空';
				}
				if (e.Property.Control == 'Table') {
					e.Config.Table.Children.forEach(children => {
						if (children.Property.Require == 0 && (children.IsShow == null || !children.IsShow) && (children.Value == null || children.Value.length == 0) && children.Property.Title[0].Text == '备注') {
							children.Value = '空';
						}
					})
				}
			})

			if (controlInfoAText == "非印刷类") {
				this.listLoading = true;
				var controlInfoB = this.templateData.TemplateContent.Controls.filter(item => {
					return item.Property.Title[0].Text == "申请类别2"
				})[0];
				var controlInfoBText = controlInfoB.Config.Selector.Options.filter(t => {
					return t.Key == controlInfoB.Value
				})[0].Value[0].Text;
				this.sendMessageData.Template = this.templateData;
				this.sendMessageData.Title = "核价";
				this.sendMessageData.Desc = "申请人：" + this.logInfo.EmpName;
				this.sendMessageData.Url = document.location.hostname +
					"/administrativeProcurementPricing?templateId=3TmB9kAg83qCoYHZcvABQiaYkXUeFAuWVr4k399d";
				let sendEmpNos = ["SC18008706", "SC02120003"];
				if (this.logInfo.EmpNo.toUpperCase() == "SC20003197") {
					sendEmpNos = ["SC20003197"];
				}
				this.sendMessageData.ToUser = sendEmpNos;
				//提交
				sendMessage(this.templateId, this.logInfo.EmpNo, this.spNo, this.sendMessageData, 1, this.logInfo.EmpName).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
				isSubmit = false;
				this.listLoading = false;
				return;
			}

			var SummaryList = [];
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];

			var control1 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "姓名" })[0];
			var control11 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "工号" })[0];
			var control2 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "部门" })[0];
			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			info.SummaryInfo.push({ "Text": "申请人：" + control1.Value + " 工号：" + control11.Value + " 申请人部门：" + control2.Value, "Lang": "zh_CN" });
			SummaryList.push(info);

			var control4 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "合计" })[0]

			var info = { SummaryInfo: [] }
			info.SummaryInfo = [];
			info.SummaryInfo.push({ "Text": "总金额：" + control4.Value, "Lang": "zh_CN" });
			SummaryList.push(info);


			this.templateData.SummaryList = SummaryList;


			//提交
			submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData, this.flowId).then(response => {
				this.Message({
					message: '申请成功',
					type: 'success',
					duration: 3 * 1000
				});
				setTimeout(() => {
					this.$router.push("/index");
				}, 3000)
			}).finally(() => {
				isSubmit = false;
				this.listLoading = false;
			});
		}
	}

}
</script>

<style scoped lang="less">
.pages {
	padding-bottom: 14px;
}
</style>
